import { Component, OnInit } from '@angular/core';
import { Subject,of } from 'rxjs';
import { filter, map, reduce } from 'rxjs/operators';

@Component({
  selector: 'app-tier-wallet',
  templateUrl: './tier-wallet.component.html',
  styleUrls: ['./tier-wallet.component.css']
})
export class TierWalletComponent implements OnInit {
  dtOptions: DataTables.Settings = {};
   dtTrigger: Subject<any> = new Subject<any>();
  constructor() { }

  ngOnInit(): void {



    const numbers$ = of(1, 2, 3, 4, 5);

    of(1, 2, 3, 4, 5),map(x=>console.log(x))

    numbers$.pipe(
      filter(num => num % 2 == 0),
      map(num => num * 10),

    ).subscribe(result => console.log(result));

    

    numbers$.pipe(map(x => x * 20)).subscribe(res => console.log(res))

    numbers$.pipe(
      filter(num => num % 2 !== 0), // Keep only odd numbers: [1, 3, 5]
      map(num => num * 10), // Multiply each by 10: [10, 30, 50]
      reduce((acc, value) => acc + value, 0) // Sum all values: 10 + 30 + 50 = 90
    ).subscribe(result => console.log('Final Result:', result));

  }

}
